function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { constructFrom } from "../constructFrom.js";
export function normalizeDates(context) {
  for (var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    dates[_key - 1] = arguments[_key];
  }

  var normalize = constructFrom.bind(null, context || dates.find(function (date) {
    return _typeof(date) === "object";
  }));
  return dates.map(normalize);
}